import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import AuthService from '../../../../Services/authService';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';

export default class MyOfficeAssignmentSummarySearchParams extends SearchParamsBase {
  static saveType = 'MyOfficeAssignmentSummarySearchParams';
  initialize() {
    this.OfficeId = MyOfficeAssignmentSummarySearchParams.getUserOffice();
    this.ClientNameOrId = '';
    this.CompletedDate = '';
  }

  // The offices of the user's office group, comma-separated (CD-5311). There is no office input on this page.
  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return OfficeHelper.GetDefaultOfficeIds(user.officeId).join(',');
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'ClientNameOrId',
      label: 'Client Name Or ID',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
  ];
}
